import { render, staticRenderFns } from "./ZippedReportsOld.vue?vue&type=template&id=80b2012a"
import script from "./ZippedReportsOld.vue?vue&type=script&lang=js"
export * from "./ZippedReportsOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports